<template>
  <span class="code leaning-20 d-flex items-center text-medium text-b14 gap-4 font-jetbrains-mono">
    <span>{{ computeId }}</span>
    <Logo name="regular" />
  </span>
</template>

<script lang="ts" setup>
import Logo from '@/components/logo/index.vue';
import { computed, toRefs } from 'vue';
const props = defineProps<{ id: string }>();
const { id } = toRefs(props);
const computeId = computed(() => (id.value?.toString().includes('ZP') ? id.value : 'ZP.' + id.value));
</script>
